<template>
  <div
    class="c-card"
    v-on:click="handleCLick"
    v-bind:style="{ backgroundImage: 'url(' + image + ')' }"
  >
    <div class="c-card__title">
      <div class="c-card__title-bg"></div>
      {{title}}
    </div>
    <div class="c-card__name">{{name}}</div>
    <div class="c-card__number">{{number}}</div>
  </div>
</template>

<script>
import Vue from "vue"; // eslint-disable-line no-unused-vars

export default {
  created() {
    this.$emit("created");
  },
  methods: {
    handleCLick() {
      console.log(this.number);
      // this.$emit("cardClicked", { date: this.date, cardNumber: this.number });
      this.$emit("cardClicked", this.number);
    }
  },
  props: ["title", "name", "number", "image", "date"]
};
</script>




// WEBPACK FOOTER //
// src/components/card.vue